import { render, staticRenderFns } from "./DateCampaignModal.vue?vue&type=template&id=36144c4a&"
import script from "./DateCampaignModal.vue?vue&type=script&lang=js&"
export * from "./DateCampaignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports